var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('full-calendar',{attrs:{"events":_vm.events,"config":_vm.config},on:{"event-selected":_vm.eventSelected,"event-drop":_vm.eventDrop,"event-resize":_vm.eventResize,"day-click":_vm.dayClick,"event-render":_vm.eventRender}})}
var staticRenderFns = []

export { render, staticRenderFns }